import React from 'react'
import './Navbar.css'
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
const NavBar = () => {
  const navigate = useNavigate();
  const handleHomeClick = () => {
    navigate('/'); 
  };

  return (
    <div>
        <div className="px-md-5 px-2 d-flex gap-3 justify-content-between align-items-center bg-white">
            <img src="images/Group.png" className='logo' onClick={handleHomeClick} alt="" />
            <div className="d-flex position-relative">
              <input type="text" className='form-control rounded-start-5 ps-4' />
              <i className='fa fa-search text-black-50 search-icon'></i>
              <div className="rounded-end-5 main-bg py-2 px-3 text-white hovers">Search</div>
            </div>
            <div className='d-flex gap-2'>
              <img src="images/bi_cart.svg" className='hovers' alt="" />
              <img src="images/ph_heart-thin.jpg" className='hovers' alt="" />
            </div>
        </div>
        <Navbar expand="lg" className='secondary-bg px-md-5 px-3 py-0 rounded-bottom-5' variant="light">
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          className="custom-toggler border-0 text-white">
          <FontAwesomeIcon icon={faBars} className="custom-toggler-icon" />
        </Navbar.Toggle>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="">
            <Nav.Link href="#" className="text-white ">
            Green Plants
            </Nav.Link>
            <Nav.Link href="#" className="text-white ">
            Flower Plants            
            </Nav.Link>
            <Nav.Link href="#" className="text-white ">
            Cacti
            </Nav.Link>
            <Nav.Link href="#" className="text-white ">
            Hanging Plants
            </Nav.Link>
            <Nav.Link href="#" className="text-white ">
            Tree Plants
            </Nav.Link>
            <Nav.Link href="#" className="text-white ">
            Gifts
            </Nav.Link>
            <Nav.Link href="#" className="text-white ">
            Subscription
            </Nav.Link>
            <Nav.Link href="#" className="text-white ">
            Accessories and Pottery
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
        <div className='d-flex align-items-center gap-1'>
          <p className='m-0 lang-text'>العربية</p>
          <img src="images/ph_globe-thin.png" className='hovers' alt="" />
        </div>
    </Navbar>
    </div>
  )
}

export default NavBar
